/**
 * 桥接函数
 * @param name 函数名
 * @param data 参数
 * @returns Promise<any>
 */

import { checkLinkedinLogin as checkLinkedinLoginApi } from "@/api";
import { getCookie as getCookieApi, getCookies as getCookiesApi } from "@/libs/chrome";
import { RuntimeMessages } from "@/config";

export const BridgeFuncMap = {
  checkLinkedinLogin: checkLinkedinLoginApi,
  getCookie: getCookieApi,
  getCookies: getCookiesApi,
};

function bridge<K extends keyof typeof BridgeFuncMap>(
  func: K,
  ...data: Parameters<(typeof BridgeFuncMap)[K]>
): Promise<ReturnType<(typeof BridgeFuncMap)[K]>> {
  return chrome.runtime.sendMessage({
    action: RuntimeMessages.Bridge,
    funcName: func,
    data: data,
  });
}

export function checkLinkedinLogin() {
  return bridge("checkLinkedinLogin");
}

export function getCookie(...args: Parameters<typeof getCookieApi>) {
  return bridge("getCookie", ...args);
}

export function getCookies(...args: Parameters<typeof getCookiesApi>) {
  return bridge("getCookies", ...args);
}
